module.exports = __webpack_public_path__ + "static/site-cover-63500f6b4e5a12e821316fc8e0c0cea7.jpg";